import { getPasskeys } from '@pba/client-auth';
import { type Pagination, type PaginationExtendedData, type Passkey, type SortOrderType, createPasskey } from 'models';
import { usePaginatedInfiniteQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { mapSortOrderNode } from 'common/utils';
import { getPasskeysInfiniteQueryKey } from './keys';

export type PasskeysQuerySorter = {
  updatedAt?: SortOrderType;
};

type P = {
  pagination: Pick<Pagination, 'pageSize'>;
  sorter?: PasskeysQuerySorter;
};

export const usePasskeysInfiniteQuery = ({ pagination, sorter }: P) =>
  usePaginatedInfiniteQuery<PaginationExtendedData<Passkey>, ApiClientResponseError<ResponseErrorDataObject>>({
    async queryFn({ pageParam: skip }) {
      const { data } = await getPasskeys<{ $limit?: number; $skip?: number; $sort?: { updatedAt?: number } }>({
        config: {
          params: {
            $limit: pagination.pageSize,
            $skip: skip,
            $sort: sorter ? { updatedAt: mapSortOrderNode(sorter.updatedAt) } : undefined,
          },
        },
      });

      return {
        data: data.data.map((passkey) => createPasskey(passkey)),
        limit: data.limit,
        skip: data.skip,
        total: data.total,
      };
    },
    queryKey: getPasskeysInfiniteQueryKey({ pagination, sorter }),
  });
